import type { HomepageHeroConfig, HomepageHeroSlideConfig } from '../constants/homepageHero';

export function sortHomepageHeroSlides(slides: HomepageHeroSlideConfig[]): HomepageHeroSlideConfig[] {
  return [...slides].sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));
}

export function activeHomepageHeroSlides(slides: HomepageHeroSlideConfig[]): HomepageHeroSlideConfig[] {
  return sortHomepageHeroSlides(slides).filter((s) => s.enabled !== false);
}

export function mergeHomepageHeroConfig(
  partial: Partial<HomepageHeroConfig> | undefined,
  defaults: HomepageHeroConfig,
): HomepageHeroConfig {
  if (!partial?.slides?.length) return defaults;
  return {
    intervalMs: partial.intervalMs ?? defaults.intervalMs,
    slides: partial.slides.map((slide, index) => ({
      ...slide,
      sortOrder: slide.sortOrder ?? index,
    })),
  };
}
